export const REACT_LOTTIE_PLAYER_VERSION = "3.5.3"; 
export const LOTTIE_WEB_VERSION = "^5.10.2";
